import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Typography,
  SxProps,
  Theme,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

interface TestDataInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled: boolean;
  isLoading: boolean;
  sx?: SxProps<Theme>;
}

const TestDataInput = ({
  value,
  onChange,
  onSubmit,
  disabled,
  isLoading,
  sx = {},
}: TestDataInputProps) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: "grey.300",
        borderRadius: 2,
        p: 2,
        bgcolor: "background.paper",
        ...sx,
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight={600}
        sx={{ mb: 1.5, fontSize: "0.875rem" }}
      >
        Test Data
      </Typography>
      <TextField
        multiline
        fullWidth
        rows={8}
        placeholder="Enter test values (one per line)..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        sx={{
          mb: 1.5,
          "& .MuiOutlinedInput-root": {
            fontFamily: "monospace",
            fontSize: "0.875rem",
            borderRadius: 1.5,
            backgroundColor: "grey.50",
            "& fieldset": {
              borderColor: "grey.300",
            },
            "&:hover fieldset": {
              borderColor: "primary.main",
            },
            "&.Mui-focused fieldset": {
              borderColor: "primary.main",
            },
          },
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          size="small"
          onClick={onSubmit}
          disabled={disabled || isLoading}
          startIcon={
            isLoading ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <PlayArrowIcon sx={{ fontSize: 18 }} />
            )
          }
          sx={{
            borderRadius: 1.5,
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.8125rem",
            px: 2,
          }}
        >
          {isLoading ? "Testing..." : "Run Test"}
        </Button>
      </Box>
    </Box>
  );
};

export default TestDataInput;
